import { GetFaqCategoriesQuery } from '@/api/sanity/generated';
import type { SearchResult } from '../hooks/useFaqSearch';
import { LINKS } from '@/constants/links';

export async function prepareSearchableItems(
	categories: NonNullable<GetFaqCategoriesQuery['allFaqCategory']>
): Promise<SearchResult[]> {
	if (!categories) {
		return [];
	}

	const searchableCategories: SearchResult[] = [];
	const searchableQuestions: SearchResult[] = [];

	for (const category of categories) {
		if (!category || !category.slug?.current) {
			continue;
		}

		searchableCategories.push({
			title: category?.name ?? '',
			description: '',
			keywords: '',
			type: 'category',
			icon: category?.icon?.asset?.url ?? '',
			slug: LINKS().faqCategory(category.slug.current),
		});

		for (const question of category.questions || []) {
			if (!question || !question.slug?.current || !category.slug?.current) {
				continue;
			}

			searchableQuestions.push({
				title: question.name ?? '',
				type: 'question',
				description: question.description ?? '',
				keywords: question.keywords || '',
				slug: LINKS().faqQuestion(category.slug.current, question.slug.current),
			});
		}
	}

	return [...searchableCategories, ...searchableQuestions].filter(Boolean) satisfies SearchResult[];
}
